/* eslint-disable prettier/prettier */
import { Logo } from '../components/shared/Logo';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card } from '../components/ui/Card';
import Illustration from '../assets/man-working.png';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { CubeBackground } from '../components/shared/CubeBackground';

export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState<{ email?: string; password?: string; general?: string }>({});
  const { login } = useAuth();

  const validate = () => {
    const newErrors: typeof errors = {};
    if (!email) newErrors.email = 'Email is required';
    else if (!/^\S+@\S+\.\S+$/.test(email)) newErrors.email = 'Email is not valid';

    if (!password) newErrors.password = 'Password is required';
    else if (password.length < 6) newErrors.password = 'Password must be at least 6 characters';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (validate()) {
      try {
        await login(email, password);
      } catch (error: any) {
        const rawMessage = error?.response?.data?.message;
        const message =
          typeof rawMessage === 'string' ? rawMessage : rawMessage?.message || 'Login failed';

        const newErrors: typeof errors = {};

        switch (message) {
          case 'Email does not exist':
            newErrors.email = 'Email does not exist';
            break;
          case 'Invalid password':
            newErrors.password = 'Password is incorrect';
            break;
          case 'Your account has been disabled. Please contact support.':
          case 'Your company is disabled. Please contact support.':
            newErrors.general = message;
            break;
          default:
            newErrors.general = 'An unexpected error occurred. Please try again.';
        }

        setErrors(newErrors);
      }
    }
  };

  return (
    <div className="relative flex items-center justify-center min-h-screen px-4 overflow-hidden bg-light">
      <CubeBackground />

      <Card className="w-full max-w-md py-14 px-10 flex flex-col items-center shadow-lg bg-white relative z-10 min-h-[550px]">
        <img
          src={Illustration}
          alt="Working Illustration"
          className="object-contain w-32 h-32 mb-6"
        />

        <div className="mb-8">
          <Logo size="lg" />
        </div>

        <form className="w-full space-y-5" onSubmit={handleSubmit} noValidate>
          {errors.general && (
            <div className="p-3 text-sm text-center text-red-700 border border-red-200 rounded bg-red-50">
              {errors.general}
            </div>
          )}

          <div>
            <Input
              className="w-full"
              value={email}
              placeholder="Email"
              type="email"
              error={!!errors.email}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrors({});
              }}
            />
            {errors.email && <p className="mt-1 text-sm text-red-500">{errors.email}</p>}
          </div>

          <div>
            <Input
              className="w-full"
              placeholder="Password"
              type="password"
              value={password}
              error={!!errors.password}
              onChange={(e) => {
                setPassword(e.target.value);
                setErrors({});
              }}
            />
            {errors.password && <p className="mt-1 text-sm text-red-500">{errors.password}</p>}
            <a href="/forgot-password" className="block mt-2 text-primary hover:underline">
              Forgot Password?
            </a>
          </div>

          <div>
            <Button className="w-full" type="submit">
              Login
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
};
